// removed by extract-text-webpack-plugin
module.exports = {"FlexCol":"global__FlexCol__35Y21","FlexRow":"global__FlexRow__SZuQG","autofill":"global__autofill__3jt4z"};


//////////////////
// WEBPACK FOOTER
// ./src/global.css
// module id = 1759
// module chunks = 2